export default __webpack_public_path__ + "static/media/computerIcon.f46d2311.svg";